import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { translation } from '../../../../utils/helpers'

// Components
import ReferencedFrom from '../ReferencedFrom'
import ReferenceApproved from '../ReferenceApproved'
import ReferenceOrderData from '../ReferenceOrderData'
import ReferenceActions from '../ReferenceActions'
import Col from '../../../elements/col'
import ReferenceContactInfo from '../ReferenceContactInfo'
import { ReferenceIcons } from '../../../elements/icons'

class ReferenceCancel extends Component {
  renderDivider () {
    return (
      <div className='refOrderApproval__divider' />
    )
  }

  render () {
    const { referenceInfo, department, onClose, setBottomBarProps } = this.props
    const customer = referenceInfo.Customer

    const actionSection = <ReferenceActions referenceInfo={referenceInfo} onClose={onClose} setBottomBarProps={setBottomBarProps} isCancellation />
    const orderData = <ReferenceOrderData referenceInfo={referenceInfo} department={department} />
    const customerInfo = <ReferenceContactInfo title={translation('58')} icon={ReferenceIcons.Customer} name={customer.Name} address={customer.Address} phone={customer.Phone} />

    const largeScreen = this.props.dimensionShow([[900, 10000]])
    const smallScreen = this.props.dimensionShow([[0, 700]])

    const column1 = () => {
      return (
        <Col>
          <ReferencedFrom referenceInfo={referenceInfo} department={department} />
          <ReferenceApproved referenceInfo={referenceInfo} />
          {smallScreen && orderData}
          {!largeScreen && customerInfo}
          {!largeScreen && actionSection}
        </Col>
      )
    }

    const column2 = () => {
      return (
        <Col>
          {orderData}
        </Col>
      )
    }

    const column3 = () => {
      return (
        <Col>
          {customerInfo}
          {actionSection}
        </Col>
      )
    }

    console.log('cancel item.....')

    return (
      <div className='refOrderApproval__content'>
        {column1()}
        {!smallScreen && this.renderDivider()}
        {!smallScreen && column2()}
        {largeScreen && this.renderDivider()}
        {largeScreen && column3()}
      </div>
    )
  }
}

ReferenceCancel.propTypes = {
  referenceInfo: PropTypes.object.isRequired,
  dimensionShow: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ReferenceCancel



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferenceCancel/index.js